import { Dictionary, SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export function getProductsDefaultQty(products: ProductModel[]): Dictionary<any> {
    const result: Dictionary<any> = {};
    products.forEach(product => {
        result[product.id] = product.minimumOrderQty > 0 ? product.minimumOrderQty : 1;
    });
    return result;
}

export function getProductDefaultQty(productId: string, qty: number): Dictionary<any> {
    const result: Dictionary<any> = {};
    result[productId] = qty > 0 ? qty : 1;
    return result;
}
